import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessageWrappedInSpan} from '../misc';
import classNames from 'classnames';

import {Checkbox, FormControl, FormControlLabel} from '@material-ui/core';

const GDPRHint = ({className, faceNote, onChange}) => {
  const linkToPrivacy = (
    <a href="/privacy" target="_blank" rel="noopener noreferrer">
      <FormattedMessageWrappedInSpan id="gdprHint.link" defaultMessage="privacy policy" />
    </a>
  );

  return (
    <>
      {faceNote &&
        <div className={classNames('gdpr-hint-consent', className)}>
          <FormControl component="fieldset">
            <FormControlLabel
              value="end"
                control={<Checkbox onChange={onChange}/>}
              label={
                <FormattedMessageWrappedInSpan
                  id="gdprHint.faceHint"
                  defaultMessage="I consent that the uploaded selfie which depicts me with regard to biometric features (especially face vectors), will be matched with our database of the corresponding event. The consent can be revoked at any time with effect for the future by notifying Sportograf."
                />
              }
              labelPlacement="end"
            />
          </FormControl>
        </div>
      }
      <div className={classNames('gdpr-hint-text', className)}>
        <FormattedMessageWrappedInSpan
          id="gdprHint.text"
          defaultMessage="For more information on data protection, please see our {link}."
          values={{link: linkToPrivacy}}
        />
      </div>
    </>
  );
};

GDPRHint.defaultProps = {
  faceNote: false,
};

GDPRHint.propTypes = {
  className: PropTypes.string,
  faceNote: PropTypes.bool,
  onChange: PropTypes.func
};

export default GDPRHint;
